import { colors } from "../../../theme/theme"

const handleCardColor = (type: string) => { 
    switch (type) {
        case 'Item':
            return colors.mainColors.verde_dstore
            
        case 'Theme':
            return colors.mainColors.roxo_delinea
        
        case 'Discipline':
            return colors.mainColors.blueberry
         
        case 'Media':
            return colors.mainColors.capri
        default:
            return 'black'
    }
    
}

export default handleCardColor